export default __webpack_public_path__ + "static/media/on-dark.a4ef48f9.svg";